import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRouteMozo = ({ children }) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user'));
console.log('Token:', token);
console.log('User:', user);

  if (!token || !user || user.role !== 'MOZO') {
    return <Navigate to="/login" />;
  }

  return children;
};

export default PrivateRouteMozo;
